// SqlUtils.ts

/**
 * basic sanitation to prevent breaking the SQL string.
 * In a real backend, use prepared statements.
 * For DuckDB-Wasm, we often concatenate strings, so escaping single quotes is vital.
 */
export const escapeSql = (value: string | number | null | undefined): string => {
    if (value === null || value === undefined) {
        return 'null'
    }
    if (typeof value === 'number') {
        return value.toString()
    }
    // Escape single quotes by doubling them (Standard SQL)
    return `'${value.toString().replace(/'/g, '\'\'')}'`
}

/**
 * Wraps column names in double quotes to handle reserved words or spaces
 */
export const quoteIdentifier = (name: string): string => {
    // Split by dot to handle "table.column" scenarios if necessary
    return name.split('.').map(part => `"${part}"`).join('.')
}
